import React, { Component } from 'react';
import {connect} from "react-redux";

import * as actionTypes from '../../store/actions/actionTypes';
import UserProfile from "../../components/UserProfile/UserProfile";
import EditUser from "../../components/EditUser/EditUser";
import * as actions from "../../store/actions";

class UserSidebar extends Component {

    editUserHandler = () => {
        this.props.onEditUser();
    };

    submitUserHandler = (user_id) => {
        this.props.onSubmitUser(user_id);
    };

    render() {
        let userProfile = '';
        if (this.props.sideDrawerOpen && !this.props.editUser) {
            // console.log('STATE: ', this.props);
            userProfile = (
                <UserProfile
                    account_id={this.props.accountId}
                    user_id={this.props.userId}
                    editUser={this.editUserHandler}
                    token={this.props.token}
                />
            )
        }
        else if (this.props.sideDrawerOpen && this.props.editUser) {
            userProfile = (
                <EditUser
                    account_id={this.props.accountId}
                    user_id={this.props.userId}
                    closeEditUser={this.editUserHandler}
                    submitEditUser={this.submitUserHandler}
                    token={this.props.token}
                />
            )
        }
        return userProfile;
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        accountId: state.auth.accountId,
        token: state.auth.token,
        userId: state.auth.userId,
        authenticationLevel: state.auth.authLevel,
        editUser: state.userSidebar.editUser
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onEditUser: () => dispatch({ type: actionTypes.EDIT_USER_TOGGLE}),
        onSubmitUser: (user_id) => dispatch({ type: actionTypes.EDIT_USER_SUBMIT, userId: user_id}, actions.setUserId(user_id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSidebar);